import { useCallback } from 'react';
import { 
  trackEvent, 
  trackError, 
  trackPerformance, 
  trackPageView,
  trackUserAction,
  trackApiCall 
} from '../utils/monitoring';
import { 
  trackBusinessMetric, 
  trackEngagement, 
  trackFeatureUsage,
  trackConversion,
  trackUserJourney 
} from '../utils/analytics';

export const useMonitoring = () => {
  const trackUserEvent = useCallback((action, details = {}) => {
    trackUserAction(action, details);
  }, []);

  const trackApiRequest = useCallback((endpoint, method, duration, status, error = null) => {
    trackApiCall(endpoint, method, duration, status, error);
  }, []);

  const trackPagePerformance = useCallback((pageName, loadTime, metrics = {}) => {
    trackPerformance('page_performance', loadTime, { page: pageName, ...metrics });
  }, []);

  const trackBusinessEvent = useCallback((metric, value, context = {}) => {
    trackBusinessMetric(metric, value, context);
  }, []);

  const trackUserEngagement = useCallback((action, page, duration = null) => {
    trackEngagement(action, page, duration);
  }, []);

  const trackFeatureEvent = useCallback((feature, action, details = {}) => {
    trackFeatureUsage(feature, action, details);
  }, []);

  const trackConversionEvent = useCallback((goal, value = null, details = {}) => {
    trackConversion(goal, value, details);
  }, []);

  const trackJourneyStep = useCallback((step, details = {}) => {
    trackUserJourney(step, details);
  }, []);

  const trackApplicationError = useCallback((error, context = {}) => {
    trackError(error, context);
  }, []);

  const trackCustomEvent = useCallback((category, action, label = null, value = null) => {
    trackEvent(category, action, label, value);
  }, []);

  const trackNavigation = useCallback((fromPage, toPage) => {
    trackPageView(toPage);
    trackEvent('Navigation', `${fromPage} -> ${toPage}`);
  }, []);

  return {
    trackUserEvent,
    trackApiRequest,
    trackPagePerformance,
    trackBusinessEvent,
    trackUserEngagement,
    trackFeatureEvent,
    trackConversionEvent,
    trackJourneyStep,
    trackApplicationError,
    trackCustomEvent,
    trackNavigation,
  };
}; 